module.exports = __webpack_public_path__ + "img/mfxx.a432d4b6.png";